export default __webpack_public_path__ + "static/media/red-icon.de14bd3a.png";